import { ChevronLeft, ChevronRight, Plus } from 'lucide-react';

import { rangeLabel, type CalendarView } from './agenda-adapter';

import type { JSX } from 'react';

const VIEWS: { id: CalendarView; label: string }[] = [
  { id: 'month', label: 'Mês' },
  { id: 'week', label: 'Semana' },
  { id: 'day', label: 'Dia' },
];

/** Toolbar da agenda: nav ‹ HOJE › + range label + seletor de vista + Novo. */
export function CalToolbar({
  view,
  cursorMs,
  onView,
  onNav,
  onToday,
  onNew,
}: {
  view: CalendarView;
  cursorMs: number;
  onView: (v: CalendarView) => void;
  onNav: (dir: number) => void;
  onToday: () => void;
  onNew: () => void;
}): JSX.Element {
  return (
    <div className="cal-toolbar">
      <div className="cal-toolbar__nav">
        <button type="button" onClick={onToday}>
          HOJE
        </button>
        <button type="button" onClick={() => onNav(-1)} aria-label="Anterior">
          <ChevronLeft size={12} />
        </button>
        <button type="button" onClick={() => onNav(1)} aria-label="Próximo">
          <ChevronRight size={12} />
        </button>
      </div>
      <h2 className="cal-toolbar__range">{rangeLabel(view, cursorMs)}</h2>
      <div style={{ flex: 1 }} />
      <div className="cal-page__viewswitch" role="tablist">
        {VIEWS.map((v) => (
          <button
            key={v.id}
            type="button"
            role="tab"
            aria-selected={view === v.id}
            className={view === v.id ? 'is-active' : ''}
            onClick={() => onView(v.id)}
          >
            {v.label}
          </button>
        ))}
      </div>
      <button type="button" className="btn btn--primary btn--sm" onClick={onNew}>
        <Plus size={12} /> Novo agendamento
      </button>
    </div>
  );
}
